import { useState } from 'react';
import { useLanguageContext } from '../context/languageContext';

export default function LivePrices({ provider }) {
  const [open, setOpen] = useState(false);
  const [tour, setTour] = useState('1132594');
  const { language } = useLanguageContext();
  const italian = language?.toLowerCase() === 'it';
  const label = language === 'sq' ? 'Zgjidhni datat dhe shikoni çmimet' : italian ? 'Scegli le date e controlla i prezzi' : 'Choose dates & check prices';
  const params = provider === 'gyg' ? {
    widget: 'availability', tour_id: tour, partner_id: 'S9W35E3', cmp: 'vivas-menu',
    locale_code: italian ? 'it-IT' : 'en-US', currency: 'EUR', variant: 'horizontal',
  } : {
    currency: 'EUR', utm_source: 'denismimini', utm_medium: 'widget', aff_code: 'a_aid',
    aff_value: 'denismimini', aff_channel: 'vivas-menu', autocomplete: 'on', responsive: 'on',
    style_form_bg_color: 'EFF6FF', style_form_font_color: '0F172A',
    style_submit_bg_color: '1D4ED8', style_submit_font_color: 'FFFFFF',
    submit_text: italian ? 'Cerca prezzi' : 'Search prices', layout_powered_by: 'on',
    widget_origin: window.location.origin,
  };
  const src = provider === 'gyg'
    ? `https://widget.getyourguide.com/default/availability.frame?${new URLSearchParams(params)}`
    : `https://widget.discovercars.com/${italian ? 'it' : 'en'}/locations/albania?${new URLSearchParams(params)}`;
  return <div className="mt-4 rounded-xl border border-slate-200 bg-white p-3">
    <button type="button" aria-expanded={open} onClick={() => setOpen(value => !value)} className="flex min-h-[48px] w-full items-center justify-between gap-2 text-left text-sm font-bold text-slate-900">{label}<span aria-hidden="true">{open ? '−' : '+'}</span></button>
    {open && <>
      {provider === 'gyg' && <select aria-label={italian ? 'Attività' : 'Activity'} value={tour} onChange={event => setTour(event.target.value)} className="mb-3 min-h-[44px] w-full rounded-lg border border-slate-300 p-2 text-sm">
        <option value="1132594">Holta Canyon & Banja Lake</option>
        <option value="949443">Sazan Island & Karaburun</option>
        <option value="1217342">Berat & Belshi Lake</option>
      </select>}
      <iframe key={src} src={src} title={`${provider === 'gyg' ? 'GetYourGuide' : 'DiscoverCars'} ${label}`} className="w-full border-0" style={{height: provider === 'gyg' ? 320 : 520}} />
      <p className="mt-2 text-xs leading-relaxed text-slate-500">{language === 'sq' ? 'Çmimet dhe disponueshmëria konfirmohen nga ofruesi për datat tuaja.' : italian ? 'Prezzi e disponibilità sono confermati dal fornitore per le date scelte.' : 'Prices and availability are confirmed by the provider for your selected dates.'}</p>
    </>}
  </div>;
}
